import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';

import axios from 'axios';
import { toast } from 'react-hot-toast';
import Input from '../../components/Form/Input';
import Select from '../../components/Form/Select';
import FormButton from '../../components/Form/Button';
import Textarea from '../../components/Form/Textarea';
import FormImage from '../../components/Form/image';
import { useParams } from 'react-router-dom';

const TestimonialEdit = () => {
      const { testimonialId } = useParams();

      const [name, setName] = useState('');
      const [position, setPosition] = useState('');
      const [companyName, setCompanyName] = useState('');
      const [message, setMessage] = useState('');
      const [image, setImage] = useState('');
      const [imageUrl, setImageUrl] = useState('');
      const [status, setStatus] = useState('');
      const [loading, setLoading] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      useEffect(() => {
            const loadData = async () => {
                  await axios
                        .get(
                              `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/testimonials/${testimonialId}`,
                              {
                                    headers: {
                                          Authorization: `Bearer ${token}`
                                    }
                              }
                        )
                        .then((response) => {
                              if (response.data.result === 'success') {
                                    setName(response.data.testimonial.name);
                                    setCompanyName(
                                          response.data.testimonial.company
                                    );
                                    setImageUrl(
                                          response.data.testimonial.image
                                    );
                                    setPosition(
                                          response.data.testimonial.position
                                    );
                                    setMessage(
                                          response.data.testimonial.message
                                    );
                                    setStatus(response.data.testimonial.status);
                              }
                        })
                        .catch((error) => {
                              toast.error(error.message);
                        });
            };

            loadData();
      }, []);

      const handleForm = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  name: name,
                  position: position,
                  message: message,
                  company: companyName,
                  image: image,
                  status: status
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/testimonials/${testimonialId}`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.name) {
                                    toast.error(response.data.message.name);
                              }
                              if (response.data.message.position) {
                                    toast.error(response.data.message.position);
                              }
                              if (response.data.message.company) {
                                    toast.error(response.data.message.company);
                              }
                              if (response.data.message.message) {
                                    toast.error(response.data.message.message);
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleForm}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader>
                                                <CardTitle>
                                                      Edit Testimonial
                                                </CardTitle>
                                                <CardLinks>
                                                      <LinkButton to="/dashboard/testimonials">
                                                            Back
                                                      </LinkButton>
                                                </CardLinks>
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <Input
                                                            title="Full Name"
                                                            classes={8}
                                                            required={true}
                                                            value={name}
                                                            handleChange={
                                                                  setName
                                                            }
                                                      />
                                                      <Select
                                                            title="Status"
                                                            classes={4}
                                                            selected={status}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                      <Input
                                                            title="Company Name"
                                                            required={false}
                                                            value={companyName}
                                                            handleChange={
                                                                  setCompanyName
                                                            }
                                                      />
                                                      <Input
                                                            title="Position"
                                                            required={false}
                                                            value={position}
                                                            handleChange={
                                                                  setPosition
                                                            }
                                                      />
                                                      <Textarea
                                                            title="Message"
                                                            required={true}
                                                            value={message}
                                                            handleChange={
                                                                  setMessage
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            required={true}
                                                            imageUrl={imageUrl}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Row>
                                                      <Col lg={12}>
                                                            <FormButton
                                                                  title="Submit"
                                                                  loading={
                                                                        loading
                                                                  }
                                                            />
                                                      </Col>
                                                </Row>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default TestimonialEdit;
